var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex flex-wrap items-center justify-end mb-4" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "fee_plans.create",
                  expression: "'fee_plans.create'",
                },
              ],
              attrs: { variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$router.push("/financial/fee_plans/create")
                },
              },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "PlusIcon" },
              }),
              _c("span", { staticClass: "align-middle" }, [
                _vm._v(_vm._s(_vm.$t("fee_plans.new"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "financial/fee_plans",
          route_grid_path: "/grid",
          order_column: "id",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID"),
                ]),
                _c("vs-th", { key: "name", attrs: { "sort-key": "name" } }, [
                  _vm._v(_vm._s(_vm.$t("fee_plans.name"))),
                ]),
                _c("vs-th", { key: "is_default" }, [
                  _vm._v(_vm._s(_vm.$t("fee_plans.default"))),
                ]),
                _c("vs-th", { key: "active_version" }, [
                  _vm._v(_vm._s(_vm.$t("fee_plans.active_version"))),
                ]),
                _c("vs-th", { key: "establishments_count" }, [
                  _vm._v(_vm._s(_vm.$t("fee_plans.establishments"))),
                ]),
                _c(
                  "vs-th",
                  { key: "created_at", attrs: { "sort-key": "created_at" } },
                  [_vm._v(_vm._s(_vm.$t("fee_plans.created_at")))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.id))]),
                    ]),
                    _c("vs-td", { key: "name", attrs: { width: "30%" } }, [
                      _c("div", { staticClass: "font-semibold" }, [
                        _vm._v(_vm._s(tr.name)),
                      ]),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(tr.description)),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "is_default", attrs: { width: "10%" } },
                      [
                        tr.is_default
                          ? _c(
                              "vs-chip",
                              {
                                staticClass: "text-base",
                                attrs: { color: "primary" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("fee_plans.default")) +
                                    " "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("—")]),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "active_version", attrs: { width: "12%" } },
                      [
                        tr.active_version
                          ? _c("div", [
                              _vm._v(
                                " v" + _vm._s(tr.active_version.version) + " "
                              ),
                              _c(
                                "small",
                                { staticClass: "text-muted d-block" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        tr.active_version.effective_from
                                          ? _vm.$utils.format.date(
                                              tr.active_version.effective_from
                                            )
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ])
                          : _c(
                              "vs-chip",
                              {
                                staticClass: "text-base",
                                attrs: { color: "warning" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("fee_plans.no_active_version"))
                                ),
                              ]
                            ),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "establishments_count", attrs: { width: "13%" } },
                      [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              tr.is_default
                                ? _vm.$t("fee_plans.all_without_custom")
                                : tr.establishments_count
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "created_at", attrs: { width: "15%" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$utils.format.date(tr.created_at))),
                        ]),
                      ]
                    ),
                    _c("vs-td", { attrs: { width: "15%" } }, [
                      _c(
                        "span",
                        { staticClass: "flex" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "fee_plans.edit",
                                expression: "'fee_plans.edit'",
                              },
                            ],
                            attrs: {
                              icon: "EditIcon",
                              "svg-classes":
                                "h-5 w-5 mr-4 hover:text-primary cursor-pointer",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(
                                  "/financial/fee_plans/" + tr.id + "/edit"
                                )
                              },
                            },
                          }),
                          !tr.is_default
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "fee_plans.delete",
                                    expression: "'fee_plans.delete'",
                                  },
                                ],
                                attrs: {
                                  icon: "Trash2Icon",
                                  "svg-classes":
                                    "h-5 w-5 hover:text-danger cursor-pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return props.destroy(tr)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }